import React, { useEffect, useState } from 'react';
import './Header.css';
import config from "../config";

// import { Link } from "react-router-dom";

const Header = ({ onLoginClick }) => {
  const [username, setUsername] = useState('');
  const [menuOpen, setMenuOpen] = useState(false); // For mobile menu toggle

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) setUsername(storedUsername);
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("You are not logged in!");
      return;
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
    }

    try {
      const response = await fetch(`${config.API_BASE_URL}api/logout/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Token ${token}`,
        },
      });

      if (response.ok) {
        alert("Logged out successfully");
        window.location.href = "/";
      } else {
        const errorData = await response.json();
        console.error("Logout failed:", errorData);
        alert("Logout failed!");
      }
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Network error during logout!");
    }

    window.location.href = "/";
  };

  const isLoggedIn = !!localStorage.getItem('token');

  return (
    <header className="header">


<div className="logo_container">
  <img
    src="https://sadhanlab.com/stock_analyzer/stock_analyzer_logo.png"
    alt="Stock Analyzer Logo"
    className="logo_img"
  />
  <div className="logo_text">Stock Analyzer</div>
</div>
{/* 




      <div className="logo">
        <img
          src="https://sadhanlab.com/stock_analyzer/stock_analyzer_logo.png"
          alt="Stock Analyzer Logo"
        />
      </div>
                    <div className="logo_text">Stock Analyzer</div> */}



      {/* Hamburger menu for mobile */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <nav className={menuOpen ? "active" : ""}>
        {isLoggedIn && (
          <span className="username">Hello, {username}</span>
        )}
        <a href="/#home">Home</a>
        <a href="/#features">Features</a>
        {!isLoggedIn && (
          <>
            <a
              href="#login"
              onClick={(e) => {
                e.preventDefault();
                if (onLoginClick) onLoginClick();
              }}
            >
              Login
            </a>
            <a
              href="/RegistrationForm"
              rel="noopener noreferrer"
            >
              Sign Up/ Reset Password
            </a>
          </>
        )}
        {isLoggedIn && (

<>
            {/* <Link to="/profile" className="nav-link">
              Update Email
            </Link> */}

          <a
            href="/updateemail"
            
          >
              Update Email
          </a>



          <a
            href="/#logout"
            onClick={(e) => {
              e.preventDefault();
              handleLogout();
            }}
          >
            Log Out
          </a>

          </>
        )}
      </nav>
    </header>
  );
};

export default Header;
